import { createContext } from 'react';
import noop from 'lodash/noop';

export default createContext({
	reportMount: noop,
});
